import { render, staticRenderFns } from "./Ppc3.vue?vue&type=template&id=3bf2a58a&scoped=true&"
import script from "./Ppc3.vue?vue&type=script&lang=js&"
export * from "./Ppc3.vue?vue&type=script&lang=js&"
import style0 from "./Ppc3.vue?vue&type=style&index=0&id=3bf2a58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2a58a",
  null
  
)

export default component.exports